import { render, staticRenderFns } from "./CalendarReservationsSimple.vue?vue&type=template&id=4c6e4b1a"
import script from "./CalendarReservationsSimple.vue?vue&type=script&lang=js"
export * from "./CalendarReservationsSimple.vue?vue&type=script&lang=js"
import style0 from "./CalendarReservationsSimple.vue?vue&type=style&index=0&id=4c6e4b1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports